import { defineStore } from 'pinia'
import { migrateFilter, FILTER_VERSION } from '@/components/timinplanner/resourceFilter'

export const useViewStore = defineStore('view', {
  state: () => ({
    actionView: 'planner',  // Default view
	username: '',
	countActiveUsers: 0,
	openProjects: [],
	allBookings: true,
	activeProjects: true,
	plannedProjects: false,
	printTimeStart: null,
	printTimeEnd: null,
	zoomVal: null,
	zoomStart: null,
	zoomEnd: null,
	zoomWidthPerDay: null,
	resourceFilters: {},
  }),
  actions: {
	isZoom() {
        return this.zoomWidthPerDay !== null;
	},
    setActionView(view) {
      this.actionView = view
    },
	setUsername(username) {
	  this.username = username
	},
	setCountActiveUsers(countActiveUsers) {
	  this.countActiveUsers = countActiveUsers
	},
    toggleProject(pid) {
      if (this.openProjects.includes(pid)) {
        this.openProjects = this.openProjects.filter(el => el !== pid);
      } else {
        this.openProjects.push(pid);
      }
	},
	isOpenProject(pid) {
		return this.openProjects.includes(pid);
	},
	setProjectFilter(all, active, planned) {
	  console.log("setProjectFilter all=" + all + " active=" + active + " planned=" + planned)
	  this.allBookings = all;
	  this.activeProjects = active;
	  this.plannedProjects = planned;
	},
	showAllBookings() {
	  return this.allBookings; 
	},
	showActiveProjects() {
	  return this.activeProjects;
	},
	showPlannedProjects() {
	  return this.plannedProjects;
	},
	// Die Filter liegen persistiert im Browser und stammen teils noch aus dem
	// alten Format; migrateFilter faengt das ab und faellt im Zweifel auf den
	// Standard zurueck.
	//
	// Bewusst OHNE Seiteneffekt: der Getter laeuft aus einem computed heraus, und
	// ein Schreibzugriff darin wuerde den Store veraendern, das computed erneut
	// ausloesen und sich im Kreis drehen. Umgeschrieben wird erst beim Speichern.
	getResourceFilter(pid) {
	  const raw = this.resourceFilters[pid];
	  return raw != null && raw.v === FILTER_VERSION ? raw : migrateFilter(raw);
	},
	setResourceFilter(pid, filter) {
	  this.resourceFilters[pid] = migrateFilter(filter);
	},
	setPrintTimeStart(startdate) {
	  this.printTimeStart = startdate;
	},
	setPrintTimeEnd(enddate) {
	  this.printTimeEnd = enddate;
	},
	setZoomVal(zoomVal) {
	  this.zoomVal = zoomVal;
	},
	setZoomStart(zoomStart) {
	  this.zoomStart = zoomStart;
	},
	setZoomEnd(zoomEnd) {
	  this.zoomEnd = zoomEnd;
	},
	setZoomWidthPerDay(width) {
	  this.zoomWidthPerDay = width;
	}
  },
  persist: {
    pick: ['actionView', 'allBookings', 'activeProjects', 'plannedProjects', 'printTimeStart', 'printTimeEnd', 'zoomVal', 'zoomStart', 'zoomEnd', 'zoomWidthPerDay', 'resourceFilters'],
  },
})
